/**
 * Shared gift → cart attribute / order-note helpers for Bag Bar cart UI.
 * Loaded before theme.js / cart-drawer.js via layout.
 */
(function (global) {
  const GIFT_NOTE_MAX = 240;
  const GIFT_NOTE_MARKER = '*** GIFT ORDER ***';
  const GIFT_NOTE_WARN_AT = 220;

  /**
   * @param {boolean} isGift
   * @param {string} giftNote
   * @returns {string}
   */
  function buildGiftOrderNote(isGift, giftNote) {
    if (!isGift) return '';
    const lines = [
      GIFT_NOTE_MARKER,
      'Fulfillment: this is a gift. Do not include prices or a receipt in the package.',
    ];
    const trimmed = String(giftNote || '')
      .trim()
      .slice(0, GIFT_NOTE_MAX);
    if (trimmed) {
      lines.push('', 'Gift note:', trimmed);
    }
    return lines.join('\n');
  }

  /**
   * @param {ParentNode | null | undefined} root
   * @returns {{ gift: string; gift_note: string; note: string }}
   */
  function readGiftCartPayload(root) {
    const check = root?.querySelector('[data-bbs-gift-check]');
    const noteEl = root?.querySelector('[data-bbs-gift-note]');
    const isGift = check instanceof HTMLInputElement && check.checked;
    const giftNote =
      isGift && noteEl instanceof HTMLTextAreaElement
        ? String(noteEl.value || '').trim().slice(0, GIFT_NOTE_MAX)
        : '';
    return {
      gift: isGift ? 'Yes' : '',
      gift_note: giftNote,
      note: buildGiftOrderNote(isGift, giftNote),
    };
  }

  /**
   * @param {string | null | undefined} value
   * @returns {boolean}
   */
  function isGiftAttribute(value) {
    const v = String(value || '')
      .trim()
      .toLowerCase();
    return v === 'yes' || v === 'true' || v === '1';
  }

  /**
   * @param {ParentNode | null | undefined} root
   */
  function syncGiftNoteCounter(root) {
    if (!root) return;
    const noteEl = root.querySelector('[data-bbs-gift-note]');
    const countEl = root.querySelector('[data-bbs-gift-note-count]');
    if (!(noteEl instanceof HTMLTextAreaElement) || !(countEl instanceof HTMLElement)) return;
    const len = Math.min(String(noteEl.value || '').length, GIFT_NOTE_MAX);
    countEl.textContent = `${len} / ${GIFT_NOTE_MAX}`;
    countEl.classList.toggle('is-near-limit', len >= GIFT_NOTE_WARN_AT);
  }

  /**
   * Checkbox disclosure + character counter for gift note fields.
   * @param {ParentNode | null | undefined} root
   */
  function bindGiftUi(root) {
    if (!root) return;
    const check = root.querySelector('[data-bbs-gift-check]');
    const wrap = root.querySelector('[data-bbs-gift-note-wrap]');
    const noteEl = root.querySelector('[data-bbs-gift-note]');

    if (check instanceof HTMLInputElement && wrap instanceof HTMLElement) {
      const syncWrap = () => {
        wrap.hidden = !check.checked;
      };
      check.addEventListener('change', syncWrap);
      syncWrap();
    }

    if (noteEl instanceof HTMLTextAreaElement) {
      noteEl.setAttribute('maxlength', String(GIFT_NOTE_MAX));
      const onInput = () => syncGiftNoteCounter(root);
      noteEl.addEventListener('input', onInput);
      noteEl.addEventListener('change', onInput);
      syncGiftNoteCounter(root);
    }
  }

  global.BbsCartGift = {
    GIFT_NOTE_MAX,
    GIFT_NOTE_MARKER,
    buildGiftOrderNote,
    readGiftCartPayload,
    isGiftAttribute,
    syncGiftNoteCounter,
    bindGiftUi,
  };
})(typeof window !== 'undefined' ? window : globalThis);
